import * as consts from './FeaturedConsts';

const initialState = {
    agentId: 0,
    listingsList: [],
    listingsCount: 0,
    agentInfo: {
        name: '',
        company: '',
        phone: '',
        mobilePhone: '',
        businessPhone: '',
        fax: '',
        email: '',
        website: '',
        orig_website: '',
        logo: '',
        photo: '',
        address: ''
    },
    listingPerPage: 10,
    getFeaturedFulfilled: false,
    getFeaturedError: ''
};

const featured = (state = initialState, action) => {
    switch (action.type) {
         case consts.SET_URL_PARAMS_FEATURED:
            return {
                ...state,
                agentId: action.payload.agentId,
            }
        case consts.GET_FEATURED_PENDING:
            return {
                ...state,
                getFeaturedFulfilled: false
            }
        case consts.GET_FEATURED_REJECTED:
            return {
                ...state,
                getFeaturedFulfilled: true
            }
        case consts.GET_FEATURED_FULFILLED:
            return {
                ...state,
                getFeaturedFulfilled: true,
                listingsList: action.payload.listings,
                listingsCount: action.payload.count,
                agentInfo: {
                    name: action.payload.agentInfo.name,
                    company: action.payload.agentInfo.company,
                    phone: action.payload.agentInfo.phone,
                    mobilePhone: action.payload.agentInfo.mobile_phone,
                    businessPhone: action.payload.agentInfo.business_phone,
                    fax: action.payload.agentInfo.fax,
                    email: action.payload.agentInfo.email,
                    website: action.payload.agentInfo.website,
                    orig_website: action.payload.agentInfo.orig_website,
                    logo: action.payload.agentInfo.logo,
                    photo: action.payload.agentInfo.photo,
                    address: action.payload.agentInfo.agent_company_address
                },
            }
        case consts.FEATURED_PAGINATION_FULFILLED:
            return {
                ...state,
                getFeaturedFulfilled: true,
                listingsList: action.payload.listings,
            }
        default:
            return state
    }
}

export default featured;
